import { LoaderCircle, Square } from 'lucide-react';
import { Button } from '../../design-system/Button';
import type { ProgressUpdate } from '../../engine/core/types';

interface ProcessingPanelProps {
  file: File;
  progress: ProgressUpdate | null;
  onCancel: () => void;
}

export function ProcessingPanel({ file, progress, onCancel }: ProcessingPanelProps): React.JSX.Element {
  const completed = progress?.completedSteps ?? 0;
  const total = progress?.totalSteps ?? 1;
  return (
    <section className="processing-panel" aria-live="polite">
      <LoaderCircle className="processing-panel__spinner" aria-hidden="true" />
      <p className="mono processing-panel__file">{file.name}</p>
      <h1>{progress?.label ?? 'Reading file'}</h1>
      <p>{progress?.detail ?? 'Local processing · no upload'}</p>
      <progress value={completed} max={total}>{completed} of {total}</progress>
      <div className="processing-panel__steps"><span>{completed} / {total} verified stages</span><span>Worker isolated</span></div>
      <Button variant="secondary" onClick={onCancel}><Square />Cancel processing</Button>
    </section>
  );
}
